import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=a92fa134&scoped=true&"
import script from "./SelectCourse.vue?vue&type=script&lang=js&"
export * from "./SelectCourse.vue?vue&type=script&lang=js&"
import style0 from "./SelectCourse.vue?vue&type=style&index=0&id=a92fa134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92fa134",
  null
  
)

component.options.__file = "SelectCourse.vue"
export default component.exports